/**
 * ** DO NOT USE THIS FILE IN NEW CODE **
 * ** DO NOT ADD NEW CODE TO THIS FILE **
 * ** This file will be removed in the future **
 *
 * @deprecated This file is a wrapper for `@tenants/utils/which-tenant` and
 * is used to provide backwards compatibility with the old tenant utils.
 */
import {
  isThemeExpCA as isThemeExpCAUtils,
  isThemeExpUS as isThemeExpUSUtils,
  isThemeExpInService as isThemeExpInServiceUtils,
  isThemeZoocasa as isThemeZoocasaUtils,
  isThemeExpCommercial as isThemeExpCommercialUtils,
  isExpTheme as isExpThemeUtils,
  isTenantExpCA as isTenantExpCAUtils,
  isTenantExpUS as isTenantExpUSUtils,
  isTenantExpInService as isTenantExpInServiceUtils,
  isZoocasaTenant as isZoocasaTenantUtils,
  isTenantExpCommercial as isTenantExpCommercialUtils,
  themeNameToTenantId,
} from '@tenants/utils/which-tenant';
import { ThemeNames } from 'types/themes';
import { FeaturesType } from 'contexts/features';

/** @deprecated Use @tenants/utils/which-tenant instead */
export const isThemeExpCA = isThemeExpCAUtils;
/** @deprecated Use @tenants/utils/which-tenant instead */
export const isThemeExpUS = isThemeExpUSUtils;
/** @deprecated Use @tenants/utils/which-tenant instead */
export const isThemeExpInService = isThemeExpInServiceUtils;
/** @deprecated Use @tenants/utils/which-tenant instead */
export const isThemeZoocasa = isThemeZoocasaUtils;
/** @deprecated Use @tenants/utils/which-tenant instead */
export const isThemeExpCommercial = isThemeExpCommercialUtils;
/** @deprecated Use @tenants/utils/which-tenant instead */
export const isExpTheme = isExpThemeUtils;

/** @deprecated Use @tenants/utils/which-tenant instead */
export const isTenantExpCA = (themeName: ThemeNames, features?: FeaturesType) => isTenantExpCAUtils(themeNameToTenantId(themeName), features);
/** @deprecated Use @tenants/utils/which-tenant instead */
export const isTenantExpUS = (themeName: ThemeNames, features?: FeaturesType) => isTenantExpUSUtils(themeNameToTenantId(themeName), features);
/** @deprecated Use @tenants/utils/which-tenant instead */
export const isTenantExpInService = (themeName: ThemeNames, features?: FeaturesType) => isTenantExpInServiceUtils(themeNameToTenantId(themeName), features);
/** @deprecated Use @tenants/utils/which-tenant instead */
export const isZoocasaTenant = (themeName: ThemeNames, features?: FeaturesType) => isZoocasaTenantUtils(themeNameToTenantId(themeName), features);
/** @deprecated Use @tenants/utils/which-tenant instead */
export const isTenantExpCommercial = (themeName: ThemeNames, features?: FeaturesType) => isTenantExpCommercialUtils(themeNameToTenantId(themeName), features);

